// Keep these links aligned with the sharing links in the native apps.
// QR assets are generated locally; opening this dialog never contacts a QR service.
export const mobileApps = {
  appStore: { url: 'https://apps.apple.com/app/id6759134131' },
  googlePlay: { url: 'https://play.google.com/store/apps/details?id=com.storex.android' },
} as const;
export const mobileAppDownload = {
  url: 'https://dev.storex.global2t.com/download-app/',
  qr: '/mobile-apps/download.svg',
} as const;
